import { OtpReq, AccessCodePayload, ChatAuthenticationState } from "../types/chat-authentication-types";
import { action } from "typesafe-actions";

export enum ChatAuthenticationActions {
    KILL_SWITCH_OTP_SUBMIT = "ChatAuthenticationActions/KILL_SWITCH_OTP_SUBMIT",
    KILL_SWITCH_OTP_RESEND = "ChatAuthenticationActions/KILL_SWITCH_OTP_RESEND",
    KILL_SWITCH_SET_SUBMIT_OTP_INFO = "ChatAuthenticationActions/KILL_SWITCH_SET_SUBMIT_OTP_INFO",
    KILL_SWITCH_SET_RESEND_OTP_INFO = "ChatAuthenticationActions/KILL_SWITCH_SET_RESEND_OTP_INFO",
    ACCESS_CODE_LOGIN = "ChatAuthenticationActions/ACCESS_CODE_LOGIN",
    KILL_SWITCH_OTP_RESET = "ChatAuthenticationActions/KILL_SWITCH_OTP_RESET"
}


export const submitOtpKillSwitchAction = (payload: OtpReq) => action(ChatAuthenticationActions.KILL_SWITCH_OTP_SUBMIT, payload);
export const resendOtpKillSwitchAction = (payload: OtpReq) => action(ChatAuthenticationActions.KILL_SWITCH_OTP_RESEND, payload);
export const setSubmitOtpInfoKillSwitchAction = (payload: ChatAuthenticationState) => action(ChatAuthenticationActions.KILL_SWITCH_SET_SUBMIT_OTP_INFO, payload);
export const setResendOtpInfoKillSwitchAction = (payload: ChatAuthenticationState) => action(ChatAuthenticationActions.KILL_SWITCH_SET_RESEND_OTP_INFO, payload);
export const accessCodeLoginAction = (payload: AccessCodePayload) => action(ChatAuthenticationActions.ACCESS_CODE_LOGIN, payload);
export const resetOtpKillSwitchAction = (payload: boolean) => action(ChatAuthenticationActions.KILL_SWITCH_OTP_RESET, payload);
